import { combineReducers } from "redux";
import cities from "./cityReducer";
import categories from "./categoryReducer";
import targetGroups from "./targetGroupReducer";
import foods from "./foodReducer";
import foodCost from "./foodCostReducer";
import events from "./eventReducer";
import attending from "./attendingReducer";
import apiCallsinProgress from "./apiStatusReducer";
import date from "./dateReducer";
import selectedCity from "./selectedCityReducer";
import user from "./userReducer";
import network from "./networkReducer";
import profiles from "./profileReducer";
import reports from "./reportReducer";
import bibleVerse from "./bibleVerseReducer";

const rootReducer = combineReducers({
  cities,
  categories,
  targetGroups,
  foods,
  foodCost,
  events,
  attending,
  apiCallsinProgress,
  date,
  selectedCity,
  user,
  network,
  profiles,
  reports,
  bibleVerse
});

export default rootReducer;